<template>
  <div class="form-group textOnInput" :class="{'is-invalid-group':error || errorMessage}">
    <div class="textOnInput">
      <label class="form-control-label" v-if="textLabel">
        {{ textLabel }}
      </label>
      <multiselect
        v-bind="$attrs"
        :searchable="searchable"
        :multiple="multiple"
        :options="options"
        :placeholder="placeholder"
        :clear-on-select="clearOnSelect"
        :close-on-select="closeOnSelect"
        :show-labels="showLabels"
        :class="{ 'is-invalid': error || errorMessage, 'is-valid': !error && !errorMessage && isSelected }"
        :label="label"
        :track-by="trackBy"
        @input="onInput"
      >
        <CheckBox
          v-if="hasCheckbox"
          slot="option" slot-scope="scope"
          :label="scope.option[label]"
          :value="scope.option.checked"
        />
      </multiselect>
    </div>
    <div class="invalid-feedback" v-if="errorMessage">
      {{ errorMessage }}
    </div>
    <div class="invalid-feedback" v-else-if="error">
      Please provide a valid {{ textLabel || name || label || 'input' }}
    </div>
    <div class="text-success" v-else-if="(!error && !errorMessage && isSelected)">
      Looks good! {{ isAllSelected ? 'Selected All' : '' }}
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Dropdown from '@src/static/dropdown'
import CheckBox from '../checkbox.vue'

export default {
  components: {
    Multiselect,
    CheckBox
  },
  props: {
    showLabels: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    },
    clearOnSelect: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    autoload: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    parameters: {
      type: Object,
      default: () => {}
    },
    placeholder: String,
    errorMessage: String,
    moduleName: String,
    endpoint: String,
    label: String,
    textLabel: String,
    trackBy: {
      type: String,
      default: '_id'
    },
    hasSelectAll: {
      type: Boolean,
      default: false
    },
    hasCheckbox: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: [],
      defaultOptions: [],
      isSelected: false,
      isAllSelected: false
    }
  },
  methods: {
    onInput(val) {
      this.isSelected = false 
      this.isAllSelected = false
      let isSelectedAll = val.length > 0 ? val.filter( res => { return this.trackBy ? res[this.trackBy] == 'all' : res == 'Select All'}) : val
      if(isSelectedAll.length > 0 && this.multiple && this.hasSelectAll) {
        this.onSelectAll(val)
      } else {
        let selected = this.getSelected(val, this.trackBy)
        
        // if(val) {
        //   this.isSelected = true
        // }
        
        if(this.hasCheckbox){
          this.checkChange(val);
        }
  
        this.$emit('input', val)
        this.$emit('selected', selected)
      }
    },
    getSelected(val, param) {
      let options = this.defaultOptions || []
      let ret

      if (typeof val == 'object') {
        this.$emit('input', val)
        return val
      }
      else {
        for (let key in options) {
          if (key && typeof options[key] == 'object' && options[key]) {
            if (options[key][param]) {
              ret = options[key]
            }
          }
          else {
            if (options && options[key] == val) {
              ret = options[key]
            }
          }
        }
      }

      return ret
    },
    checkChange(val) {
      this.isSelected = val.length > 0 ? true : false
      this.options = this.options.map(res => {
        res.checked = false
        return res
      })
      for(let key in val) {
        const element = val[key];
        let index = this.options.findIndex(item => item[this.trackBy]==element[this.trackBy]);
        this.options[index].checked = true;
      }
    },
    fetchData() {
      let param = {}
      let moduleName = this.moduleName || ''

      if (Dropdown[moduleName]) {
        this.options = Dropdown[moduleName]
        this.defaultOptions = Dropdown[moduleName]
      }
      else {
        param = {
          ...this.parameters,
          ...param
        }

        return this.$store.dispatch(`${moduleName}/${this.endpoint}`, param)
        .then(res => {
          if (res && res.data) {
            let { data } = res

            if (data.data) {
              data = data.data
            }

            this.options = data
            this.defaultOptions = data

            if(this.multiple && this.hasSelectAll) {
              let selectAll = null
              if(this.trackBy) {
                selectAll = {
                  [this.trackBy]: 'all',
                  [this.label || 'name']:'Select All'
                }
              }

              this.options = [selectAll || 'Select All'].concat(data)
            }
          }
        })
        .catch(err => console.log(err))
      }
    },
    onSelectAll(val) {
      let isNotAllSelected = this.defaultOptions.length == val.length - 1
      let selected = !isNotAllSelected ? [...this.defaultOptions] : []

      if(this.hasCheckbox) {
        let checked = selected.length > 0 ? [...this.options] : []
        this.checkChange(checked)
      }
      // this.isSelected = !isNotAllSelected
      this.isAllSelected = !isNotAllSelected

      this.$emit('input', selected)
      this.$emit('selected', selected)
    } 
  },
  mounted () {
    if (this.autoload) {
      this.fetchData()
    }
  }
}
</script>
<style lang="scss">

.multiselect__tag {
  // border-radius: 16px;
  background: #EBEBEB !important;
  color: rgba(0, 0, 0, 0.87);
}


.multiselect__tag-icon {
  right: 4px;
  top: 4px;
  width: 13.33px;
  height: 13.33px;
  line-height: 13.33px;
  border-radius: 13.33px;
  background: #EBEBEB!important;

  &:after {
    color: #AEAEAE !important;
  }
}

.multiselect__option {
  // font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  // line-height: 23px;
}
.multiselect__option--selected {
  // background: rgba(235, 47, 91, 0.20);
  color: var(--text-active, rgba(0, 0, 0, 0.87));
  background: rgba(174, 174, 174, 0.40);
}
</style>